import { render, staticRenderFns } from "./submission.vue?vue&type=template&id=59f537ec&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./submission.vue?vue&type=script&lang=js"
export * from "./submission.vue?vue&type=script&lang=js"
import style0 from "./submission.vue?vue&type=style&index=0&id=59f537ec&prod&scoped=true&lang=css"
import style1 from "./submission.vue?vue&type=style&index=1&id=59f537ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f537ec",
  null
  
)

export default component.exports